import { container } from "assets/jss/material-kit-react.jsx";
import imagesStyles from "assets/jss/material-kit-react/imagesStyles";
import commonVariables from "assets/jss/material-kit-react/commonVariables";
import commonStyles from "assets/jss/material-kit-react/commonStyles";

var windowInnerHeight = typeof window !== `undefined` ? window.innerHeight : 0;
var windowInnerWidth = typeof window !== `undefined` ? window.innerWidth : 0;

const layoutStyle = {
  container,
  ...imagesStyles,
  ...commonStyles,
  main: {
    background: "#fff",
    position: 'fixed',
    zIndex: "3"
  },
  mainRaised: {
    marginTop: '0px',
    marginLeft: '0px',
    marginRight: '0px',
    //padding: '10px 10px 10px 10px',
    minHeight: windowInnerHeight,
    minWidth: windowInnerWidth,
    maxWidth: windowInnerWidth,
    borderRadius: "10px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  header: {
    display: 'flex', 
    justifyContent: 'flex-start', 
    alignItems: 'center',
    minHeight: '100px',
    maxHeight: '100px',
    borderBottom: `2px solid ${commonVariables.color.primary}`,
    backgroundColor: commonVariables.color.background
  },
  logoSmall: {
    textAlign: "center",
    "& img": {
      maxWidth: "150px",
      width: "100%",
      margin: "0 auto"
    }
  },
  content: {
    padding: 0,
    minHeight: windowInnerHeight - 100, 
    minWidth: windowInnerWidth, 
    //backgroundColor: '#0f05'
  },
  


};

export default layoutStyle;
